import { createSelector } from '@reduxjs/toolkit'
import _find from 'lodash/find'
import moment from 'moment-timezone'

const getProfileSlice = (state) => state.profile
const getUserDiscounts = (state) => getProfileSlice(state).userDiscounts || []
const pluckId = (_state, { id }) => id

const getIsStillApplied = (appliedDate, discountDurationMonths) =>
    moment().isSameOrBefore(moment(appliedDate).add(discountDurationMonths, 'M'))
const getIsCurrentlyApplied = ({ active, appliedDateUTC, discountSchemeDurationMonths }) =>
    !active && getIsStillApplied(appliedDateUTC, discountSchemeDurationMonths)
const getCurrentlyAppliedDiscount = createSelector([getUserDiscounts], (userDiscounts = []) =>
    _find(userDiscounts, getIsCurrentlyApplied)
)

const filterUnused = ({ active }) => active
const sortByDateAscending = (a, b) => new Date(b.updatedDateUTC) - new Date(a.updatedDateUTC)
const getNextDiscountsToApply = createSelector([getUserDiscounts], (userDiscounts = []) =>
    [...userDiscounts.filter(filterUnused)].sort(sortByDateAscending)
)

export const getTaxReturnDiscount = createSelector([getUserDiscounts, pluckId], (userDiscounts = [], taxReturnId) => {
    const taxReturnDiscount = userDiscounts.find((userDiscount) => userDiscount.taxReturnId === taxReturnId)
    if (!taxReturnDiscount) return { hasAppliedDiscount: false }

    const { discountSchemePercentageDiscount: discountPercentage } = taxReturnDiscount

    return {
        ...taxReturnDiscount,
        discountPercentage: discountPercentage ?? 0,
        hasAppliedDiscount: true,
    }
})

export const getQuarterlyTaxReturnsAnnualSummaryDiscount = createSelector(
    [getUserDiscounts, pluckId],
    (userDiscounts = [], quarterlyTaxReturnsAnnualSummaryId) => {
        const quarterlyTaxReturnsAnnualSummaryDiscount = userDiscounts.find(
            (userDiscount) => userDiscount.quarterlyTaxReturnsAnnualSummaryId === quarterlyTaxReturnsAnnualSummaryId
        )
        if (!quarterlyTaxReturnsAnnualSummaryDiscount) return { hasAppliedDiscount: false }

        const { discountSchemePercentageDiscount: discountPercentage } = quarterlyTaxReturnsAnnualSummaryDiscount

        return {
            ...quarterlyTaxReturnsAnnualSummaryDiscount,
            discountPercentage: discountPercentage ?? 0,
            hasAppliedDiscount: true,
        }
    }
)

export default createSelector(
    getCurrentlyAppliedDiscount,
    getNextDiscountsToApply,
    (currentlyAppliedDiscount, [nextDiscountToApply]) => {
        const meetsDiscoundConditions = !currentlyAppliedDiscount && !!nextDiscountToApply
        const discountPercentage = meetsDiscoundConditions ? nextDiscountToApply.discountSchemePercentageDiscount : 0
        const discountDurationMonths = meetsDiscoundConditions ? nextDiscountToApply.discountSchemeDurationMonths : 0

        return {
            activeDiscount: currentlyAppliedDiscount || nextDiscountToApply,
            discountDurationMonths,
            discountPercentage,
            hasAppliedDiscount: !!currentlyAppliedDiscount || !!nextDiscountToApply,
        }
    }
)
